import { SWRFetcher } from '@commenda/utils';
import useSWR, { KeyedMutator } from 'swr';
import { API_BASE_PATH } from './constants';
import { TAgentFirmClientsV2Response } from './types';

type UseAgentFirmUserClientsOptions = {
  agentFirmId: string;
  userId: string;
  enabled?: boolean;
};

/**
 * Hook to fetch clients assigned to a specific agent firm user
 * GET /agent-firm/:agentFirmId/users/:userId/clients
 */
export function useAgentFirmUserClients(
  options: UseAgentFirmUserClientsOptions
) {
  const { agentFirmId, userId, enabled = true } = options;

  const url =
    agentFirmId && userId
      ? `${API_BASE_PATH}/${agentFirmId}/users/${userId}/clients`
      : null;

  const {
    data,
    error,
    mutate,
    isLoading,
  }: {
    data?: TAgentFirmClientsV2Response;
    error?: unknown;
    mutate: KeyedMutator<TAgentFirmClientsV2Response>;
    isLoading: boolean;
  } = useSWR(
    enabled && url ? url : null,
    SWRFetcher({
      method: 'GET',
    })
  );

  return {
    data: data?.clients ?? [],
    count: data?.count ?? 0,
    error,
    mutate,
    isLoading,
  };
}
